export default __webpack_public_path__ + "static/media/normal.926000f6.png";